import { render, staticRenderFns } from "./flow_produce.vue?vue&type=template&id=1fb1d182&scoped=true"
import script from "./flow_produce.vue?vue&type=script&lang=js"
export * from "./flow_produce.vue?vue&type=script&lang=js"
import style0 from "./flow_produce.vue?vue&type=style&index=0&id=1fb1d182&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1d182",
  null
  
)

export default component.exports